import React, { useContext } from 'react';
import { BridleContext } from '../BridleContextProvider';
import { findMatchingProductFromProductId } from '../HelperFunctions';

const BridleImage = () => {
    const { options, products } = useContext(BridleContext);
    const bridlePieces = Object.assign({}, options);
    delete bridlePieces['Color'];
    delete bridlePieces['Reins'];

    const images = Object.values(bridlePieces)
        .map(value => {
            return value.productId === -1 ? value : findMatchingProductFromProductId(value.productId, products);
        })
        .filter(product => product !== undefined)
        .map(product => {
            return product.productId === -1
                ? { name: 'unselected bridle piece', file: product.image }
                : { name: product.productName, file: product.image };
        });

    const reinPage = window.location.pathname === '/bridle-builder/reins';
    const reviewPage = window.location.pathname === '/bridle-builder/review';

    const showReinImage = reinPage || reviewPage;
    const reinImage = options.Reins.image ? options.Reins.image : '';

    return (
        <div className="grid-layout builder-image">
            {images.length > 0 && (
                <div className={`bridle-image-container ${reinImage && showReinImage ? 'width-6/12' : 'width-12/12'}`}>
                    {images.map((image, index) => {
                        return (
                            <img
                                key={index}
                                className="bridle-image"
                                src={`/images/bridlebuilder/${image.file}?width=500`}
                                alt={image.name}
                                width="500"
                                height="500"
                            />
                        );
                    })}
                </div>
            )}
            {showReinImage && reinImage && (
                <div className="width-4/12">
                    <img className="rein-image" src={`/images/bridlebuilder/${reinImage}?width=500`} alt="Rein Type" width="500" height="500" />
                </div>
            )}
            {!images.length && <p className="empty-image">Choose your crownpiece and size</p>}
        </div>
    );
};

export default BridleImage;
